<template>
  <div>
    <VueSelect class="select-wrapper" v-model="_value" transition="" v-bind="$attrs">
      <div slot="no-options">{{noHitsText}}</div>
    </VueSelect>
  </div>
</template>

<script>

import VueSelect from 'vue-select';

export default {
  name: 'Select',
  components: {
    VueSelect,
  },
  inheritAttrs: false,
  props: {
    value: {},
    noHitsText: {type: String, default: "Haku ei tuottanut osumia"}
  },
  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
  },
};

</script>

<style scoped>
  .select-wrapper >>> {
    @import '~vue-select/dist/vue-select.css';
  }

  .select-wrapper {
    background: white;
  }

  .select-wrapper >>> .vs__dropdown-toggle {
    border-color: var(--gray-3);
    border-radius: 0;
  }

  .select-wrapper >>> .vs__dropdown-menu {
    border-color: var(--gray-3);
    border-radius: 0 0 4px 4px;
  }
</style>
